// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import vuetify from '@/plugins/vuetify'
import VueSweetAlert from 'vue-sweetalert'
import Swal from 'sweetalert2'
import VueSession from 'vue-session'
import VueMask from 'v-mask'
import 'bootstrap/dist/css/bootstrap.css'
// import vueXlsxTable from 'vue-xlsx-table'
import axios from 'axios' // api
import moment from 'moment-timezone' // แปลง date
// import moment from 'moment' // แปลง date
// import { PivotViewPlugin } from '@syncfusion/ej2-vue-pivotview'

import * as VueGoogleMaps from 'vue2-google-maps'
import VueCustomTooltip from '@adamdehaven/vue-custom-tooltip'
import VueClipboard from 'vue-clipboard2'
import GAuth from 'vue-google-oauth2'
import { logError, syncOfflineErrors } from './utils/errorLogger'
const gauthOption = {
  clientId: '98104331104-1vtghokkaevmou3r1qiajsuc4kmi0f29.apps.googleusercontent.com',
  scope: 'profile email openid https://www.googleapis.com/auth/calendar https://www.googleapis.com/auth/calendar.events',
  prompt: 'consent'
  // prompt: 'select_account'
}
Vue.use(GAuth, gauthOption)
VueClipboard.config.autoSetContainer = true
Vue.use(VueClipboard)
Vue.prototype.$firebase = window.firebase

Vue.use(VueCustomTooltip, {
  name: 'VueCustomTooltip',
  color: '#fff',
  background: '#000',
  borderRadius: 10,
  fontWeight: 900
})
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyCnDosnYWNnKQxLbsI5Cy_iw_VC5oyc1Ck',
    libraries: 'places',
    region: 'TH',
    language: 'th'
  }
})

Vue.prototype.$profile_dev = {
  'displayName': 'Pamorn Trivorrarat',
  'pictureUrl': 'https://profile.line-scdn.net/0heYkOVB2MOnZGNizwjMlECTZmORxlR2NkYlMmRXNhZhF8USomP1knFSZjN0N9ACh1OlR9QnozbBNKJU0QWGDGQkEGZEF_AXkpall0lQ',
  // 'pictureUrl': 'https://profile.line-scdn.net/0hehdTWCiWOkdZLRKhl6VFEGVoNCouAzwPIUl2JX4pNnQnSHsUMRx8dCgoNCUmTS1BMRhzKHQpMyN9',
  'statusMessage': 'ใช้ไลน์อันนี้นะคร้าบ',
  'userId': 'Ud2e630e20bb8597b90d4908a46fbc4e9'
  // 'userId': 'Ubb981ed38ad6dd18734560d2203df255'
}

// Vue.use(PivotViewPlugin)

Vue.config.productionTip = false
Vue.use(Swal)
Vue.use(VueSweetAlert)
Vue.use(VueSession)
Vue.use(VueMask)
// Vue.use(vueXlsxTable, {rABS: false})

Vue.prototype.$omise_public_key = 'pkey_test_5pyxhrcj5hv0pb3azgd'
Vue.prototype.$liff_id_login = '1654154168-E3mxd54W'
Vue.prototype.$liff = window.liff
Vue.prototype.$OmiseCard = window.OmiseCard
Vue.config.productionTip = false
Vue.mixin({
  data: function () {
    return {
      checkShopSigneture: {
        'U59422b6ffb95aea0fd17b0b79bcc9895': true,
        'U2537f5c842f9c075ea23d57edfc51459': true,
        'Ue769a7b0e8b967b573f763eaba3ab70b': true,
        'U61a07d2a464114354571a25defb8789a': true,
        'Uded6fe88c383ca08639135cd5844afe2': true,
        'U543e0cfdac298365dbe4cb3a41ed6fd4': true,
        'Uc0257a24f9cdca58141c9306ea673f1f': true,
        'SD_1774575719812': true
      },
      shopNameData: {
        puenBaan: 'Uc0257a24f9cdca58141c9306ea673f1f',
        creativeliveidea: 'U543e0cfdac298365dbe4cb3a41ed6fd4',
        airmate: 'U59422b6ffb95aea0fd17b0b79bcc9895',
        onsitebBetaskSignature: 'Ue769a7b0e8b967b573f763eaba3ab70b',
        motta: 'U0c232da5722cb2b5a650c196f89ae797',
        joyrideDemo: 'U310b4c8934a2781f2c8bdfd73e8f295f',
        joyrideProd: 'U9f316c85400fd716ea8c80d7cd5b61f8',
        ayasan: 'U61a07d2a464114354571a25defb8789a',
        assa: 'Uded6fe88c383ca08639135cd5844afe2',
        numchai: 'U2537f5c842f9c075ea23d57edfc51459',
        flowHair: 'Ub39f8cdb604e2cfc335ff4d09e9260f0',
        noppakao: 'U2e87a7ec1a1c3238aef9e361469360fc',
        pharathonburi: 'Ude4022cc0f518ce833a7a00ecd4ffba3',
        testNoppakao: 'Uacb057e915191f96b53a9e41db1b2573',
        udon1: 'Ufd665b99e51600de2fad93c4a7cf7918',
        udon2: 'Ub349e98ba23530706bada2fe0eb640ca',
        krungthaihospital: 'U79b1d89002896a2238b7020e7be95075',
        samkokevent: 'U512ca78be8cd402fd96f57d5f6aca6f3',
        yara: 'U059b0cfd106275615e322e0406240ef9',
        cJAutoGallery: 'Ucd348d8b9a2bfc005c95ba4db59c4eb4',
        toda: 'U30089980e23d60a1ffd4f0fd747b37ed',
        todaList: [
          'U30089980e23d60a1ffd4f0fd747b37ed',
          'SD_1778581744206'
        ],
        // toda: 'U486f54a62eba1076dd4af9e42af89fb9',
        themall: 'U3e16601f14a37a066d00cecbb4b8394c',
        englishMunmun: 'Ub7cbc419244731cdd682354dd0e57cef',
        englishMunmunCoppyTest: 'Ua214787f52cd3f62110a4917f3c21407',
        vietjet: 'Uaec5861a8e24be55160294a4c5b083fe',
        evaAir: 'SD_1751340630924',
        facebookThailand: 'U36e2f29cf56d05c6adb221278d32c64d',
        velaEntertainment: 'U5febfe1716555403fb9073cff3b2fb84',
        popMart: 'SD_1749721816532',
        krungthaiWesternHospital: 'SD_1760436097862',
        krungthaiWesternHospitalPkm: 'Uef6c98c8dd77361b52bdce5e8a019b14',
        air3Event: 'SD_1761811676715',
        testDriveGeely: 'U849582b67d89c975c83e37055175da45',
        centralPattana: 'Ub97e53a50d6d1805d188df50e83b1a53',
        officeOmbudsman: 'Uc1107ca5ad523dddf958cf92c78c85de',
        wonderfruitTaxi: 'Uef33e2271382f6c1dcfc56f4f7d11d59',
        soWonderland: 'U390e413c5348f590bf31f842cee8555b',
        martech2026: 'Uc6adbb9b6ff2d7c2193f297dc57dc388',
        tofuSkincare: 'SD_1710128417400',
        bestsmile: 'U9084920b3005bd1dcb57af1ae6bdba32',
        talingchanDev: 'Ufad7754f10a886803ead4d0fcabfefe3'
      },
      globalVar: 'global',
      PK: '', // Primary Key
      ApplicationKey: '', // Token
      IPPotocalENV_Production: 'https://api-belinked.betaskthai.tech',
      // IPPotocalENV_Production: 'https://pretest-api.betaskthai.tech',
      IPPotocalENV_ProductionBetask: 'https://customer-core.betaskthai.com',
      IPPotocalENV_ProductionLoyalty: 'https://api-beloyalty-productions.betaskthai.tech',
      IPPotocalENV_Developer: 'https://hw.api-belinked.betaskthai.com',
      // IPPotocalENV_Developer: 'http://localhost:5001',
      // IPPotocalENV_Developer: 'http://localhost:5001',
      IPPotocalENV_DeveloperBetask: 'http://localhost:5006',
      // IPPotocalENV_DeveloperLoyalty: 'http://localhost:5001',
      IPPotocalENV_DeveloperLoyalty: 'https://api-beloyalty-productions.betaskthai.tech',
      // IPPotocalENV_DeveloperLoyalty: 'http://localhost:5004',
      main_profile: {
        userLineuserId: 'U97a2b1814542579b9e5d7c1b891538ab',
        pictureUrl: 'https://profile.line-scdn.net/0hI98EFerAFhYFPD-Dk3VpQTl5GHtyEhBefVoNdiA_SSMtWFdIbV0KIiU9HCApCFUSbVxZJSZpSyQh',
        token: 'TU2c2a6a5eaf2a8f410404714bc8d05e035368ceafd65c028636a6e0a1558f255f9077bbce0fa8fe0feca559406f365a68'
      },
      dataItem: [],
      dataItemImport: [],
      export_data: [],
      searchAll: '',
      dataReady: true,
      monthNamesThai: ['', 'ม.ค', 'ก.พ', 'มี.ค', 'เม.ย', 'พ.ค', 'มิ.ย', 'ก.ค', 'ส.ค', 'ก.ย', 'ต.ค', 'พ.ย', 'ธ.ค'],
      styleCloseBt: 'color:red;font-size:20px;'
    }
  },
  methods: {
    // Flow.servicePointCount เก็บเป็น JSON string [{textTh,textEn}] (หรือ array แล้วถ้า parse มาก่อน) — คืน [] เสมอเมื่อ parse ไม่ได้
    // ใช้โดยหน้าใหม่ (BeFood/setting_queue_sound) — ManageUser / BookingForwardQueue ยังใช้ parseServicePointCount ของตัวเอง ไม่แตะ
    parseServicePointCountGlobal (servicePointCount) {
      if (!servicePointCount) return []
      if (Array.isArray(servicePointCount)) return servicePointCount
      try {
        const data = JSON.parse(servicePointCount)
        return Array.isArray(data) ? data : []
      } catch (error) {
        return []
      }
    },
    isTodaShop (shopId) {
      return this.shopNameData.todaList.includes(shopId)
    },
    // แปลงค่า fieldValue ของ Checkbox ให้เป็น array เสมอ
    // ข้อมูลเก่าใน DB มีทั้ง '' (ยังไม่เคยติ๊ก), '""' และค่าที่ไม่ใช่ JSON
    // ซึ่งทำให้ JSON.parse พัง : Unexpected end of JSON input
    parseCheckboxValue (value) {
      if (value === null || value === undefined || value === '') return []
      if (Array.isArray(value)) return value
      try {
        let parsed = JSON.parse(value)
        if (Array.isArray(parsed)) return parsed
        // '""' จะ parse ได้เป็น '' ซึ่งไม่ใช่ array
        if (parsed === null || parsed === '') return []
        return [parsed]
      } catch (error) {
        // ค่าเก่าที่เก็บเป็นข้อความธรรมดา ไม่ใช่ JSON
        console.log('parseCheckboxValue error : ', value, error)
        return []
      }
    },
    // แปลง optionField ของ Checkbox / Radio / Selects / Image ให้เป็น array เสมอ
    parseOptionField (value) {
      if (value === null || value === undefined || value === '') return []
      if (Array.isArray(value)) return value
      try {
        let parsed = JSON.parse(value)
        return Array.isArray(parsed) ? parsed : []
      } catch (error) {
        console.log('parseOptionField error : ', value, error)
        return []
      }
    },
    getFlexColor () {
      const session = this.$session && this.$session.getAll ? this.$session.getAll() : {}
      const data = session.data || {}
      const flexColor = data.flexColor

      if (flexColor === undefined || flexColor === null || flexColor === false) return ''

      const color = String(flexColor).trim()
      if (color === '' || color.toLowerCase() === 'false') return ''

      return color
    },
    getFlexColorText () {
      const session = this.$session && this.$session.getAll ? this.$session.getAll() : {}
      const data = session.data || {}
      const flexColorText = data.flexColorText

      if (flexColorText === undefined || flexColorText === null || flexColorText === false) return ''

      const colorText = String(flexColorText).trim()
      if (colorText === '' || colorText.toLowerCase() === 'false') return ''

      return colorText
    },
    hasFlexColor () {
      return this.getFlexColor() !== ''
    },
    async getDataLineConfig (shopId) {
      let dataLineConfig = []
      await axios.get(this.$DNS_IP + '/lineconfig/get?shopId=' + shopId).then(response => {
        let rs = response.data
        if (rs.status === false) {
          dataLineConfig = {
            liffMainID: '1656581804-7KRQyqo5',
            liffBookingFormID: '1656581804-32mk7OgE',
            liffBookingFormEmpID: '1656581804-b09WBwkP',
            liffMainIDLoyalty: '1656906322-JN5MM8Ep',
            checkConfig: false
          }
        } else {
          dataLineConfig = rs[0]
        }
      }).catch((error) => {
        console.log(error)
        dataLineConfig = {
          liffMainID: '1656581804-7KRQyqo5',
          liffBookingFormID: '1656581804-32mk7OgE',
          liffBookingFormEmpID: '1656581804-b09WBwkP',
          liffMainIDLoyalty: '1656906322-JN5MM8Ep',
          checkConfig: false
        }
      })
      return dataLineConfig
    },
    formatNumber (value) {
      if (value && value !== 0) {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      } else {
        return 0
      }
    },
    format_date (value) {
      if (value) {
        return moment(moment(new Date(value)), 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss')
        // return moment(String(value)).format('YYYY-MM-DD HH:mm:ss')
      }
    },
    format_dateFUllTime (value) {
      if (value) {
        return moment(moment(new Date(value)), 'DD/MM/YYYY HH:mm:ss').format('DD/MM/YYYY HH:mm:ss')
        // return moment(String(value)).format('DD/MM/YYYY HH:mm:ss')
      }
    },
    format_dateNotime (value) {
      if (value) {
        return moment(moment(new Date(value), 'DD/MM/YYYY').toDate()).format('DD/MM/YYYY')
        // return moment(String(value)).format('DD/MM/YYYY')
      }
    },
    format_dateThai (value) {
      if (value) {
        // return moment(String(value)).format('DD') + ' ' + this.monthNamesThai[moment(String(value)).format('M')]
        return moment(moment(new Date(value), 'DD/MM/YYYY').toDate()).format('DD') + ' ' + this.monthNamesThai[moment(moment(new Date(value), 'DD/MM/YYYY').toDate()).format('M')]
      }
    },
    // YYYY-MM-DD
    momenDate_1 (value) {
      if (value) {
        // return moment(String(value)).format('YYYY-MM-DD')
        return moment(moment(new Date(value), 'YYYY-MM-DD').toDate()).format('YYYY-MM-DD')
      }
    },
    // HH:MM:ss
    momenTime (value) {
      if (value) {
        // return moment(String(value)).format('HH:mm')
        return moment(moment(new Date(value), 'HH:mm').toDate()).format('HH:mm')
      }
    },
    momenDate_YYYY (value) {
      if (value) {
        return moment(String(value)).format('YYYY')
      }
    },
    momenDate_MM (value) {
      if (value) {
        return moment(String(value)).format('MM')
      }
    },
    getGetToken (DNS_IP) {
      this.ApplicationKey = ''
      axios
        .get(
          // eslint-disable-next-line quotes
          DNS_IP +
          '/system_token/getKey?tokenName=' + this.$session.getAll().AccessKey
        )
        .then(async (response) => {
          axios
            .get(
              // eslint-disable-next-line quotes
              DNS_IP +
              '/master_application/get?masApplicationName=HRM'
            )
            .then(async (response) => {
              this.ApplicationKey = response.data[0].masApplicationToken
              this.$session.set('ApplicationKey', response.data[0].masApplicationToken)
            })
            // eslint-disable-next-line handle-callback-err
            .catch((error) => {
              // this.$router.push('/Core/LoginFailed')
              this.$router.push('/Core/Login?access=' + this.$session.getAll().AccessKey)
              console.log(error)
            })
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          // this.$router.push('/Core/LoginFailed')
          console.log(error)
        })
    },
    getNowGlobal () {
      const today = new Date()
      // console.log(today)
      const date =
        today.getFullYear() +
        '-' +
        (today.getMonth() + 1) +
        '-' +
        today.getDate()
      const time =
        today.getHours() +
        ':' +
        today.getMinutes() +
        ':' +
        today.getSeconds() +
        ':' +
        today.getMilliseconds()
      const dateTime = date + ' ' + time
      return dateTime
    },
    generateCodeGlobal () {
      const today = new Date()
      // console.log(today)
      const code =
        today.getFullYear() +
        '' +
        (today.getMonth() + 1) +
        '' +
        today.getDate() +
        '' +
        today.getHours() +
        '' +
        today.getMinutes() +
        '' +
        today.getSeconds() +
        '' +
        today.getMilliseconds()
      return code
    },
    async getRunningCodeGlobal (DNS_IP, CODE) {
      var RUNCODE = ''
      const today = new Date()
      var DT = {
        runningCode: today.getFullYear() + '' + (today.getMonth() + 1) + '' + today.getDate() + '' + today.getHours() + '' + today.getMinutes() + '' + today.getSeconds() + '' + today.getMilliseconds(),
        runningName: CODE,
        runningYear: today.getFullYear(),
        runningMonth: (today.getMonth() + 1)
      }
      await axios
        .get(
          // eslint-disable-next-line quotes
          DNS_IP + '/system_running/' + "get?RECORD_STATUS=N&runningName=" + this.code +
          '&runningYear=' + today.getFullYear() +
          '&runningMonth=' + (today.getMonth() + 1),
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          console.log('getRunningCode', response.data[0])
          var rs = response.data[0]
          // console.log('Number;', rs.runningNumber)
          var number = Number(rs.runningNumber) + 1 // 1234
          // console.log('Convert : ', String(number))
          var str = String(number)
          var pad = '000'
          var ans = pad.substring(0, pad.length - str.length) + str
          // console.log('ANS : ', ans)
          //
          DT.runningNumber = ans
          //
          // console.log(DT)
          await axios
            .post(
              // eslint-disable-next-line quotes
              DNS_IP + '/system_running/' + "edit/" + rs.runningID,
              DT,
              {
                headers: {
                  'Application-Key': this.$session.getAll().ApplicationKey
                }
              }
            )
            .then(async (response) => {
              console.log('Success', rs.runningName + '' + rs.runningYear + '' + rs.runningMonth + '' + ans)
              RUNCODE = rs.runningName + '' + rs.runningYear + '' + rs.runningMonth + '' + ans
            })
            // eslint-disable-next-line handle-callback-err
            .catch((error) => {
              console.log('error function system_running : ', error)
            })
        })
        // eslint-disable-next-line handle-callback-err
        .catch(async (error) => {
          // console.log('ไม่พบข้อมูลให้เพิ่ม')
          //
          DT.runningNumber = '001'
          //
          console.log(JSON.stringify(DT))
          await axios
            .post(
              // eslint-disable-next-line quotes
              DNS_IP + '/system_running/' + "add",
              DT,
              {
                headers: {
                  'Application-Key': this.$session.getAll().ApplicationKey
                }
              }
            )
            .then(async (response) => {
              RUNCODE = DT.runningName + '' + DT.runningYear + '' + DT.runningMonth + '' + DT.runningNumber
            })
            // eslint-disable-next-line handle-callback-err
            .catch((error) => {
              console.log('error function system_running : ', error)
            })
        })
      return RUNCODE
    },
    async getDataGlobal (DNS_IP, PATH, shopId) {
      // Clear Data ทุกครั้ง
      this.dataItem = []
      // Clear ข้อมูลใน Import
      this.dataItemImport = []
      // Clear ช่องค้นหา
      this.searchAll = ''

      // console.log('Test Global')

      await axios
        .get(
          // eslint-disable-next-line quotes
          DNS_IP + PATH + "get?shopId=" + shopId,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          console.log('getData', response.data)
          this.dataReady = true
          this.dataItem = response.data
          this.export_data = response.data
          if (this.dataItem.length === 0 || this.dataItem.status === false) {
            this.dataItem = []
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
          this.$swal('ผิดพลาด', 'ไม่มีข้อมูล', 'error')
          this.dataReady = true
        })
    },
    async getDataByIdGlobal (DNS_IP, PATH, FIELD_PK_NAME, id) {
      this.PK = id
      await axios
        .get(
          // eslint-disable-next-line quotes
          DNS_IP + PATH + "getID?" + FIELD_PK_NAME + "=" + id,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          console.log('get id : ', response)
          this.dataReady = true
          if (response.data) {
            Object.assign(this.formUpdate, response.data)
            // delete this.formUpdate[FIELD_PK_NAME]
            delete this.formUpdate['LAST_DATE']
            delete this.formUpdate['CREATE_DATE']
            delete this.formUpdate['RECORD_STATUS']
            console.log('getDataById', this.formUpdate)
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dataReady = true
          console.log('error function getDataById : ', error)
        })
    },
    async addDataGlobal (DNS_IP, PATH, DT) {
      this.$swal({
        title: 'ต้องการ เพิ่มข้อมูล ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async (result) => {
          await axios
            .post(
              // eslint-disable-next-line quotes
              DNS_IP + PATH + "add",
              DT,
              {
                headers: {
                  'Application-Key': this.$session.getAll().ApplicationKey
                }
              }
            )
            .then(async (response) => {
              // Debug response
              console.log('addDataGlobal DNS_IP + PATH + "add"', response)

              this.$swal('เรียบร้อย', 'เพิ่มข้อมูล เรียบร้อย', 'success')
              // Close Dialog
              this.dialogAdd = false

              // Load Data
              await this.getDataGlobal(DNS_IP, PATH)
            })
            // eslint-disable-next-line handle-callback-err
            .catch((error) => {
              console.log('error function addDataGlobal : ', error)
              this.dataReady = true
            })
        })
        .catch((error) => {
          console.log('error function addData : ', error)
          this.dataReady = true
        })
    },
    async editDataGlobal (DNS_IP, PATH, ID, DT) {
      this.$swal({
        title: 'ต้องการ แก้ไขข้อมูล ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async (result) => {
          await axios
            .post(
              // eslint-disable-next-line quotes
              DNS_IP + PATH + "edit/" + ID,
              DT,
              {
                headers: {
                  'Application-Key': this.$session.getAll().ApplicationKey
                }
              }
            )
            .then(async (response) => {
              // Debug response
              console.log('editDataGlobal DNS_IP + PATH + "edit"', response)

              this.$swal('เรียบร้อย', 'แก้ไขข้อมูล เรียบร้อย', 'success')
              // Close Dialog
              this.dialogEdit = false

              // Load Data
              await this.getDataGlobal(DNS_IP, PATH)
            })
            // eslint-disable-next-line handle-callback-err
            .catch((error) => {
              this.dataReady = true
              console.log('error function editDataGlobal : ', error)
            })
        })
        .catch((error) => {
          this.dataReady = true
          console.log('error function editDataGlobal : ', error)
        })
    },
    async deleteDataGlobal (DNS_IP, PATH, ID, shopId) {
      this.$swal({
        title: 'ต้องการ ลบข้อมูล ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#fa0202',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async (result) => {
          await axios
            .post(
              // eslint-disable-next-line quotes
              DNS_IP + PATH + "delete/" + ID,
              this.formUpdate,
              {
                headers: {
                  'Application-Key': this.$session.getAll().ApplicationKey
                }
              }
            )
            .then(async (response) => {
              // Debug response
              console.log('DNS_IP + PATH + "delete/"', response)

              this.$swal('เรียบร้อย', 'ลบข้อมูลเรียบร้อย', 'success')
              // Close Dialog
              this.dialogDelete = false

              // Load Data
              await this.getDataGlobal(DNS_IP, PATH, shopId)
            })
            // eslint-disable-next-line handle-callback-err
            .catch((error) => {
              this.dataReady = true
              this.$swal('ผิดพลาด', 'ผิดพลาด -1', 'error')
              console.log('error function deleteDataGlobal : ', error)
            })
        })
        .catch((error) => {
          this.dataReady = true
          this.$swal('ผิดพลาด', 'ผิดพลาด -2', 'error')
          console.log('error function deleteDataGlobal : ', error)
        })
    },
    async searchDataAllGlobal (DNS_IP, PATH, DT) {
      this.dataReady = false
      this.dataItem = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          DNS_IP + PATH + "find_advanced" + DT,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          // Clear Search All
          this.searchAll = ''
          this.dataReady = true
          this.dataItem = response.data
          this.export_data = response.data
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log('error function searchDataAllGlobal : ', error)
          this.clearSearch()
          this.$swal('ผิดพลาด', 'ไม่มีข้อมูล', 'error')
          this.dataReady = true
          this.getDataGlobal(DNS_IP, PATH)
        })
    },
    async saerchDataAdvancedGlobal (DNS_IP, PATH, DT) {
      this.dataReady = false
      this.dataItem = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.$DNS_IP + this.path + "get?RECORD_STATUS=N&" + DT,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          console.log(response.data)
          this.dataReady = true
          this.dataItem = response.data
          this.export_data = response.data
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log('error function saerchDataAdvancedGlobal : ', error)
          this.$swal('ผิดพลาด', 'ไม่มีข้อมูล', 'error')
          this.dataReady = true
          this.getDataGlobal(DNS_IP, PATH)
        })
    },
    async getDataFromAPI (url, fieldId, fieldName, param) {
      let result = []
      await axios
        .get(this.$DNS_IP + `${url}?shopId=${this.session.data.shopId}${param}`)
        .then(response => {
          let rs = response.data
          if (rs.length > 0) {
            for (var i = 0; i < rs.length; i++) {
              let d = rs[i]
              let s = {}
              s.text = d[fieldName]
              s.value = d[fieldId]
              s.allData = d
              result.push(s)
            }
          } else {
            result = []
          }
        })
      return result
    }
  }
})
Vue.component('my-currency-input', {
  props: ['value'],
  template: `
          <input type="text" v-model="displayValue" @blur="isInputActive = false" @focus="isInputActive = true"/>
     `,
  data: function () {
    return {
      isInputActive: false
    }
  },
  computed: {
    displayValue: {
      get: function () {
        if (this.isInputActive) {
          // Cursor is inside the input field. unformat display value for user
          return this.value.toString()
        } else {
          // User is not modifying now. Format display value for user interface
          return this.value
            .toFixed(2)
            .replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, '$1,')
        }
      },
      set: function (modifiedValue) {
        // Recalculate value after ignoring "$" and "," in user input
        // eslint-disable-next-line no-useless-escape
        let newValue = parseFloat(modifiedValue.replace(/[^\d\.]/g, ''))
        // Ensure that it is not NaN
        if (isNaN(newValue)) {
          newValue = 0
        }
        // Note: we cannot set this.value as it is a "prop". It needs to be passed to parent component
        // $emit the event so that parent component gets it
        this.$emit('input', newValue)
      }
    }
  }
})

// ========================================
// ประตูของฟีเจอร์เรียกคิวพร้อมกัน
// ========================================
// ร้านที่ปล่อยให้ใช้แล้ว — เพิ่ม/ลบที่นี่ที่เดียว ทุก component ใช้ตัวนี้ตัวเดียว
// ฝั่ง backend มีลิสต์คู่กันที่ src/controllers/BookingForwardQueue.py
// (SIMULTANEOUS_CALL_SHOP_IDS) ต้องแก้ให้ตรงกันทั้งสองที่
Vue.prototype.$SIMULTANEOUS_CALL_SHOP_IDS = [
  'Ufad7754f10a886803ead4d0fcabfefe3', // โรงพยาบาลสัตว์ตลิ่งชัน -dev
  'U18d33b78d7011117f164cdf3ef386f7e' // โรงพยาบาลสัตว์ตลิ่งชัน (ร้านจริง)
]

Vue.prototype.$isSimultaneousCallShop = function (shopId) {
  return this.$SIMULTANEOUS_CALL_SHOP_IDS.indexOf(String(shopId || '')) >= 0
}

// ========================================
// Setup DNS Configuration (Global - ครั้งเดียว)
// ========================================
// ใช้ Vue.prototype เพื่อให้ทุก component เข้าถึงได้โดยไม่ต้องใช้ mounted hook
if (process.env.NODE_ENV === 'development') {
  // Development Mode - ใช้ Production API
  Vue.prototype.$DNS_IP = 'http://localhost:5001' // QA local ชั่วคราว (ของเดิม: https://api-belinked.betaskthai.tech)
  Vue.prototype.$DNS_IP_Betask = 'https://customer-core.betaskthai.com'
  Vue.prototype.$DNS_IP_Loyalty = 'https://api-beloyalty-productions.betaskthai.tech'

  // หากต้องการใช้ Local Development แทน ให้เปลี่ยนเป็น:
  // Vue.prototype.$DNS_IP = 'http://127.0.0.1:5001'
  // Vue.prototype.$DNS_IP_Betask = 'http://localhost:5006'
  // Vue.prototype.$DNS_IP_Loyalty = 'http://localhost:5001'
} else {
  // Production Mode
  Vue.prototype.$DNS_IP = 'https://api-belinked.betaskthai.tech'
  Vue.prototype.$DNS_IP_Betask = 'https://customer-core.betaskthai.com'
  Vue.prototype.$DNS_IP_Loyalty = 'https://api-beloyalty-productions.betaskthai.tech'
}

// ----------- Global Error Logger Setup -----------
Vue.config.errorHandler = function (err, vm, info) {
  if (err && err._isLoggedByAxios) return // 🛑 ไม่ปริ้น/ไม่ส่งซ้ำ ถ้าถูก Axios แจ้งเตือนไปแล้ว
  console.error('Vue Error Captured:', err, info)
  logError(err && err.message, `Vue Component: ${info}`, null, null, err)
}

window.onerror = function (message, source, lineno, colno, error) {
  if (error && error._isLoggedByAxios) return // 🛑 ป้องกันส่งซ้ำ
  logError(message, source, lineno, colno, error)
  return false
}

window.addEventListener('unhandledrejection', function (event) {
  if (event.reason && event.reason._isLoggedByAxios) return // 🛑 ข้ามกล่องดักจับกว้างๆ เพราะ Axios กล่องเฉพาะเจาะจงส่งไปแล้ว
  logError((event.reason && event.reason.message) || 'Unhandled Promise Rejection', 'Promise/API', null, null, event.reason)
})

axios.interceptors.response.use(
  function (response) { return response },
  function (error) {
    const config = error.config || {}
    const errorUrl = config.url || 'Unknown API URL'
    const method = config.method ? config.method.toUpperCase() : 'UNKNOWN'
    const status = error.response ? error.response.status : 'Network/CORS Error'

    let responseData = 'No Response Data'
    try { responseData = error.response ? JSON.stringify(error.response.data) : 'No Response Data' } catch (e) {}

    const cleanMessage = `API Error [${status}]: ${method} ${errorUrl} - ${error.message}`

    logError(
      cleanMessage,
      `Axios Interceptor (Status: ${status})`,
      null,
      null,
      error,
      JSON.stringify({ requestPayload: config.data || null, responseData: responseData })
    )

    error._isLoggedByAxios = true // 🏷️ แปะป้ายประกาศว่า "Error ก้อนนี้ส่งเข้าเว็บฮุคไปแล้ว ห้ามใครส่งซ้ำอีก!"

    return Promise.reject(error)
  }
)

syncOfflineErrors()
// ------------------------------------------------

/* eslint-disable no-new */
new Vue({
  el: '#app',
  vuetify,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js